<div *ngIf="isLoading">
  <p>Uploading Module Version... Please wait.</p>
  <div class="spinner"></div>
</div>
